import { system } from 'styled-system'

const cursorConfig = {
  cursor: {
    property: 'cursor' as const,
  },
}

export const cursor = system(cursorConfig)
